export const OPEN_SMALL_MODAL = 'OPEN_SMALL_MODAL';

const openSmallModal = (modalType, data) => (
  (dispatch) => {
    dispatch({
      type: OPEN_SMALL_MODAL,
      modalType,
      data,
    });
  }
);

export default openSmallModal;
